<div class="qa-email-options">
  <b class="txt">{{_(KEYS.EDITOR.EMAIL_SENDING_TO)}}</b>
  <span class="txt">{{_(KEYS.EDITOR.EMAIL_RECIPIENTS_FIXED)}}</span>
  <table style="width: 100%">
    <tr>
      <td>
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-envelope-o"></i></span>
          <input
            class="form-control"
            [ngClass]="{'is-invalid': recipientsInvalid}"
            [ngModel]="recipientsFixedStr"
            (ngModelChange)="recipientsFixedStr = $event; onRecipientsChanged()"
            placeholder="mail1@example.com, mail2@example.com">
        </div>
        <div *ngIf="recipientsInvalid" class="invalid-feedback" style="display:block">
          {{_(KEYS.EDITOR.EMAIL_RECIPIENTS_INVALID)}}
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="form-check options">
          <input
            id="sendToAssigner"
            class="form-check-input"
            type="checkbox"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="question.options.email.sendToAssigner">
          <label class="form-check-label" for="sendToAssigner">
            {{_(KEYS.EDITOR.EMAIL_SEND_TO_ASSIGNER)}}
          </label>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="form-check options">
          <input
            id="sendToFiller"
            class="form-check-input"
            type="checkbox"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="question.options.email.sendToFiller">
          <label class="form-check-label" for="sendToFiller">
            {{_(KEYS.EDITOR.EMAIL_SEND_TO_FILLER)}}
          </label>
        </div>
      </td>
    </tr>
  </table>

  <b class="txt">{{_(KEYS.EDITOR.EMAIL_WHAT_TO_SEND)}}</b>
  <table style="width: 100%">
    <tr>
      <td>
        <div class="form-check options">
          <input
            id="attachFilledPdf"
            class="form-check-input"
            type="checkbox"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="question.options.email.attachFilledPdf">
          <label class="form-check-label" for="attachFilledPdf">
            {{_(KEYS.EDITOR.EMAIL_ATTACH_FILLED_PDF)}}
          </label>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="form-check options">
          <input
            id="attachReportPdf"
            class="form-check-input"
            type="checkbox"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="question.options.email.attachReportPdf">
          <label class="form-check-label" for="attachReportPdf">
            {{_(KEYS.EDITOR.EMAIL_ATTACH_REPORT_PDF)}}
          </label>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="form-check options">
          <input
            id="includeAssetLinks"
            class="form-check-input"
            type="checkbox"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="question.options.email.includeAssetLinks">
          <label class="form-check-label" for="includeAssetLinks">
            {{_(KEYS.EDITOR.EMAIL_INCLUDE_ASSET_LINKS)}}
          </label>
        </div>
      </td>
    </tr>
  </table>
</div>


